'use client';

import {useTheme} from 'next-themes';
import {useLocation} from '@tanstack/react-router';
import {Toaster as Sonner} from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({...props}: ToasterProps) => {
  const {theme = 'system'} = useTheme();
  const {pathname} = useLocation();
  const isCanvas = pathname.startsWith('/flow/');

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className='toaster group'
      position='top-left'
      offset={isCanvas ? 56 : 4}
      style={{zIndex: 2147483647, left: '50%'}}
      gap={2}
      visibleToasts={1}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-[#313131] group-[.toaster]:text-white group-[.toaster]:border-none group-[.toaster]:shadow-[0_0px_1px_0_rgba(0,0,0,0.30),0_8px_20px_0_rgba(0,0,0,0.08)] group-[.toaster]:rounded-2xl group-[.toaster]:w-auto group-[.toaster]:min-w-fit group-[.toaster]:!min-h-12 group-[.toaster]:py-3.5 group-[.toaster]:text-center group-[.toaster]:justify-center group-[.toaster]:duration-150 group-[.toaster]:text-sm group-[.toaster]:font-semibold group-[.toaster]:-translate-x-1/2',
          title: 'group-[.toast]:!font-semibold',
          description: 'group-[.toast]:!text-white',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          loading: 'group-[.toaster]:bg-white group-[.toaster]:!text-black',
          success:
            'group-[.toaster]:!bg-[hsla(205,100%,52%,1)] group-[.toaster]:text-white',
          error:
            'group-[.toaster]:bg-[hsla(26,100%,50%,1)] group-[.toaster]:text-white',
        },
      }}
      {...props}
    />
  );
};

export {Toaster};
